module.exports = __webpack_public_path__ + "img/430404_BD9295_7E1E21_94544C-256px.021b9582.png";